export const environment = {
  production: false,
  apiUrl: 'https://api.staging.covergrup.es',
};
